module.exports = __webpack_public_path__ + "static/img/4.fa08dc2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/4.png
// module id = WHNH
// module chunks = 0